module.exports = __webpack_public_path__ + "27558c8dc8f52d2419095258a41e1f37.svg";